import { c as _c } from "react/compiler-runtime";
import { ImageCdn } from '@openclassrooms/images-cdn';
import { styled } from '@classify/react-core-components/styles';
import Typography from '@classify/react-core-components/Typography';
import Button from '@classify/react-core-components/Button';
import ContentWrapper from '@classify/react-core-components/ContentWrapper';
import Stack from '@classify/react-core-components/Stack';
import Section from '@classify/react-core-components/Section';
import ApplyButton from '../applications/components/ApplyButton';
import LeftImageSrc from './images/left.jpg';
import RightImageSrc from './images/right.jpg';
interface Props {
  buttonProps?: React.ComponentProps<typeof Button>;
  title: string;
  text: string;
  cta: string;
}
const Root = styled(Section)(({
  theme: {
    palette,
    spacing
  }
}) => ({
  margin: spacing(4, 0),
  padding: spacing(3, 0),
  backgroundColor: palette.layout.background.main
}));
const TextWrapper = styled(Stack)(({
  theme: {
    breakpoints
  }
}) => ({
  textAlign: 'center',
  order: 3,
  [breakpoints.up('md')]: {
    order: 'unset',
    width: 452
  }
}));
const ImageWrapper = styled('div')(({
  theme: {
    breakpoints
  }
}) => ({
  '& img': {
    width: 144,
    height: 174,
    [breakpoints.up('sm')]: {
      width: 190,
      height: 230
    },
    [breakpoints.up('md')]: {
      width: 219,
      height: 264
    },
    [breakpoints.up('lg')]: {
      width: 279,
      height: 336
    }
  }
}));
const PushPathListBanner = t0 => {
  const $ = _c(20);
  const {
    buttonProps: t1,
    title,
    text,
    cta
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const buttonProps = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      xs: "center",
      md: "space-between"
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ImageWrapper><ImageCdn src={LeftImageSrc} alt="" width={279} height={336} /></ImageWrapper>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== title) {
    t5 = <Typography variant="h2">{title}</Typography>;
    $[4] = title;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== text) {
    t6 = <Typography variant="subheading" component="p">{text}</Typography>;
    $[6] = text;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <ApplyButton />;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      mt: 2
    };
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== buttonProps || $[11] !== cta) {
    t9 = <Button variant="tertiary" data-event="Button|Clicked|find-my-study-program" sx={t8} {...buttonProps}>{cta}</Button>;
    $[10] = buttonProps;
    $[11] = cta;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t5 || $[14] !== t6 || $[15] !== t9) {
    t10 = <TextWrapper direction="column" alignItems="center" gap={2}>{t5}{t6}{t7}{t9}</TextWrapper>;
    $[13] = t5;
    $[14] = t6;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <ImageWrapper><ImageCdn src={RightImageSrc} alt="" width={279} height={336} /></ImageWrapper>;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t10) {
    t12 = <Root><ContentWrapper><Stack direction="row" justifyContent={t3} gap={4} flexWrap="wrap">{t4}{t10}{t11}</Stack></ContentWrapper></Root>;
    $[18] = t10;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  return t12;
};
export default PushPathListBanner;